import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26ceab64"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "nk-popper-item-wrapper" }
const _hoisted_3 = { class: "nk-popper-item flex gap-2 cursor-pointer !hover:bg-gray-100" }
const _hoisted_4 = { class: "block" }
const _hoisted_5 = { class: "nk-popper-item flex gap-2 cursor-pointer !hover:bg-gray-100" }
const _hoisted_6 = { class: "block" }
const _hoisted_7 = { class: "nk-popper-item flex gap-2 cursor-pointer !hover:bg-gray-100" }
const _hoisted_8 = { class: "block" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block uppercase font-semibold" }, "|", -1))
const _hoisted_10 = { class: "block uppercase font-semibold" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block uppercase font-semibold" }, "|", -1))
const _hoisted_12 = { class: "block uppercase font-semibold" }
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_17 = { class: "font-bold" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_19 = { class: "font-bold" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_21 = { class: "font-bold" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_23 = { class: "font-bold" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_25 = { class: "font-bold" }

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {orderBy} from 'lodash';

import { useGetInspectionGroupsQuery } from '@/entities/inspection-group/hooks';
import { useGetDeviceQuery } from '@/entities/device/hooks';
import { useGetTypeQuery } from '@/entities/type/hooks';

import { InspectionGroup } from '@/entities/inspection-group/types';

import {
  NkContainer,
  NkButton,
  NkStack,
  NkEntry,
  NkBox,
  NkGroup,
  NkHeading,
  NkBadge,
  NkInlineModal,
  NkIcon,
  NkPopper,
} from '@/core/components';

import NkSubDeviceList from '@/entities/device/components/NkSubDeviceList.vue';
import NkInspectionGroupTable
  from '@/entities/inspection-group/components/InspectionGroupTable.vue';
import NkInspectionKeyFigure from '@/entities/inspection/components/InspectionKeyFigures.vue';
import NkDeviceUpdateForm from '@/entities/device/components/form/DeviceUpdateForm.vue';
import NkDeviceByTypeCreateForm from '@/entities/device/components/form/DeviceByTypeCreateForm.vue';
import NkDeviceDeleteForm from '@/entities/device/components/form/DeviceDeleteForm.vue';
import NkDeviceCloneForm from '@/entities/device/components/form/DeviceCloneForm.vue';
import NkInspectionGroupCreateForm
  from '@/entities/inspection-group/components/form/InspectionGroupCreateForm.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkDevice',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const deviceQueryData = computed(() => ({ id: Number(route.params.device) }));
const hasDeviceQueryData = computed(() => !!deviceQueryData.value.id);
const { data: currentDevice } = useGetDeviceQuery(deviceQueryData, {
  enabled: hasDeviceQueryData,
});
const hasCurrentDevice = computed(() => !!currentDevice.value);
const hasCurrentDeviceParent = computed(() => !!currentDevice.value?.parent);
const currentDeviceName = computed(() => currentDevice.value?.deviceValues.find(deviceValue => deviceValue.reference === 'name')?.value || '-');

const deviceValues = computed(() => ({
  model: currentDevice.value?.deviceValues.find(o => o.reference === 'model')?.value,
  hubHeight: currentDevice.value?.deviceValues.find(o => o.reference === 'hubHeight')?.value,
  rotorDiameter: currentDevice.value?.deviceValues.find(o => o.reference === 'rotorDiameter')?.value,
  inServiceDate: currentDevice.value?.deviceValues.find(o => o.reference === 'inServiceDate')?.value,
  long: currentDevice.value?.deviceValues.find(o => o.reference === 'longitude')?.value,
  lat: currentDevice.value?.deviceValues.find(o => o.reference === 'latitude')?.value,
  area: currentDevice.value?.deviceValues.find(o => o.reference === 'area')?.value,
}));

const typeQueryData = computed(() => ({ id: currentDevice.value?.type }));
const { data: type } = useGetTypeQuery(typeQueryData, {
  enabled: hasCurrentDevice,
});

// Fetching for inspectionGroups
const currentDeviceInspectionGroups = computed(() => currentDevice.value?.inspectionGroups || []);
const hasInspectionGroups = computed(() => !!currentDeviceInspectionGroups.value.length);
const inspectionGroupsQueryFilters = computed(() => ({
  ids: [...currentDeviceInspectionGroups.value],
}));
const { data: inspectionGroups } = useGetInspectionGroupsQuery({
  enabled: hasInspectionGroups,
}, inspectionGroupsQueryFilters);

const getLastInspectionGroup = computed(() => orderBy(inspectionGroups.value, ['date'], ['desc'])?.[0] || null);
const onInspectionGroupCreation = (item: InspectionGroup) => {
  if (item?.lastInspectionFromFirstDevice) {
    router.push({
      name: 'visionair-inspection',
      params: {
        inspection: item.lastInspectionFromFirstDevice,
      },
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NkContainer), { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_unref(NkStack), { spacing: 8 }, {
        default: _withCtx(() => [
          (_unref(currentDevice))
            ? (_openBlock(), _createBlock(_unref(NkBox), { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NkStack), { spacing: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NkGroup), { position: "apart" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NkGroup), { spacing: 4 }, {
                            default: _withCtx(() => [
                              (_unref(type) && _unref(type).svg)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "device-svg-wrapper",
                                    innerHTML: _unref(type).svg
                                  }, null, 8, _hoisted_1))
                                : _createCommentVNode("", true),
                              _createVNode(_unref(NkHeading), { type: "underlined" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(currentDeviceName)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NkGroup), { spacing: 4 }, {
                            default: _withCtx(() => [
                              (_ctx.$store.getters['connection/isGranted'](['inspection_group_create']))
                                ? (_openBlock(), _createBlock(_unref(NkInlineModal), {
                                    key: 0,
                                    title: _ctx.$t('inspection-group.action.add'),
                                    class: "max-w-screen-md"
                                  }, {
                                    content: _withCtx(() => [
                                      _createVNode(NkInspectionGroupCreateForm, {
                                        device: _unref(deviceQueryData).id,
                                        onSubmitted: onInspectionGroupCreation
                                      }, null, 8, ["device"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_unref(NkButton), { icon: "NkNoteAdd" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('inspection-group.action.add')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["title"]))
                                : _createCommentVNode("", true),
                              (_ctx.$store.getters['connection/isGranted'](['device_clone','device_edit','device_delete']))
                                ? (_openBlock(), _createBlock(_unref(NkPopper), {
                                    key: 1,
                                    styled: "",
                                    placement: "bottom-end"
                                  }, {
                                    reference: _withCtx(() => [
                                      _createVNode(_unref(NkButton), {
                                        circle: "",
                                        icon: "NkPendingPoint"
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_2, [
                                        (_ctx.$store.getters['connection/isGranted'](['device_clone']) && !_unref(hasCurrentDeviceParent))
                                          ? (_openBlock(), _createBlock(_unref(NkInlineModal), {
                                              key: 0,
                                              title: _ctx.$t('device.action.clone_device'),
                                              class: "max-w-screen-md"
                                            }, {
                                              content: _withCtx(({close}) => [
                                                _createVNode(NkDeviceCloneForm, {
                                                  id: _unref(deviceQueryData).id,
                                                  onSubmitted: close
                                                }, null, 8, ["id", "onSubmitted"])
                                              ]),
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_3, [
                                                  _createVNode(_unref(NkIcon), { name: "NkBuild" }),
                                                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('device.action.clone_device')), 1)
                                                ])
                                              ]),
                                              _: 1
                                            }, 8, ["title"]))
                                          : _createCommentVNode("", true),
                                        (_ctx.$store.getters['connection/isGranted'](['device_edit']))
                                          ? (_openBlock(), _createBlock(_unref(NkInlineModal), {
                                              key: 1,
                                              title: _ctx.$t('device.action.edit'),
                                              class: "max-w-screen-md"
                                            }, {
                                              content: _withCtx(({close}) => [
                                                _createVNode(NkDeviceUpdateForm, {
                                                  id: _unref(deviceQueryData).id,
                                                  onSubmitted: close
                                                }, null, 8, ["id", "onSubmitted"])
                                              ]),
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_5, [
                                                  _createVNode(_unref(NkIcon), { name: "NkPencil" }),
                                                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('device.action.edit')), 1)
                                                ])
                                              ]),
                                              _: 1
                                            }, 8, ["title"]))
                                          : _createCommentVNode("", true),
                                        (_ctx.$store.getters['connection/isGranted'](['device_delete']))
                                          ? (_openBlock(), _createBlock(_unref(NkInlineModal), {
                                              key: 2,
                                              title: _ctx.$t('device.action.device_delete'),
                                              class: "max-w-screen-md"
                                            }, {
                                              content: _withCtx(({close}) => [
                                                _createVNode(NkDeviceDeleteForm, {
                                                  id: _unref(deviceQueryData).id,
                                                  onSubmitted: close
                                                }, null, 8, ["id", "onSubmitted"])
                                              ]),
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_7, [
                                                  _createVNode(_unref(NkIcon), { name: "NkDelete" }),
                                                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('device.action.device_delete')), 1)
                                                ])
                                              ]),
                                              _: 1
                                            }, 8, ["title"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NkGroup), {
                        spacing: 4,
                        class: "bg-gray-100 p-2 text-xxs flex items-center w-fit"
                      }, {
                        default: _withCtx(() => [
                          (_unref(type))
                            ? (_openBlock(), _createBlock(_unref(NkBadge), {
                                key: 0,
                                size: "sm",
                                plain: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(type).name), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_unref(getLastInspectionGroup))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_9,
                                _createElementVNode("span", _hoisted_10, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('inspection.last_inspection')) + " : ", 1),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.$format(_unref(getLastInspectionGroup)?.date)), 1)
                                ]),
                                _hoisted_11,
                                _createElementVNode("span", _hoisted_12, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('inspection.next_theoretical_inspection')) + " : ", 1),
                                  _createVNode(_unref(NkBadge), {
                                    type: "success",
                                    size: "sm",
                                    plain: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$format(_unref(getLastInspectionGroup)?.theoricalNextInspectionDate)), 1)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NkGroup), null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('misc.model')) + " :", 1),
                            _createTextVNode(" " + _toDisplayString(_unref(deviceValues).model), 1)
                          ]),
                          _hoisted_14,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('misc.rotorDiameter')) + " :", 1),
                            _createTextVNode(" " + _toDisplayString(_unref(deviceValues).rotorDiameter), 1)
                          ]),
                          _hoisted_16,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('misc.hubHeight')) + " :", 1),
                            _createTextVNode(" " + _toDisplayString(_unref(deviceValues).hubHeight), 1)
                          ]),
                          _hoisted_18,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('misc.inServiceDate')) + " :", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.$format(_unref(deviceValues).inServiceDate)), 1)
                          ]),
                          _hoisted_20,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('misc.long')) + " :", 1),
                            _createTextVNode(" " + _toDisplayString(_unref(deviceValues).long), 1)
                          ]),
                          _hoisted_22,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('misc.lat')) + " :", 1),
                            _createTextVNode(" " + _toDisplayString(_unref(deviceValues).lat), 1)
                          ]),
                          _hoisted_24,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('misc.area')) + " :", 1),
                            _createTextVNode(" " + _toDisplayString(_unref(deviceValues).area), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(NkEntry), {
            title: _ctx.$t('misc.key_figures')
          }, {
            default: _withCtx(() => [
              _createVNode(NkInspectionKeyFigure)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_unref(NkEntry), {
            title: _ctx.$t('misc.inspections')
          }, {
            default: _withCtx(() => [
              _createVNode(NkInspectionGroupTable, {
                type: "device",
                "entity-data": _unref(deviceQueryData),
                "show-root-farm": false,
                "show-root-device": false
              }, null, 8, ["entity-data"])
            ]),
            _: 1
          }, 8, ["title"]),
          (!!_unref(type)?.childrenForModel.length)
            ? (_openBlock(), _createBlock(_unref(NkEntry), {
                key: 1,
                title: _ctx.$t('misc.subDevices')
              }, _createSlots({
                default: _withCtx(() => [
                  _createVNode(NkSubDeviceList, {
                    device: _unref(deviceQueryData).id
                  }, null, 8, ["device"])
                ]),
                _: 2
              }, [
                (_unref(currentDevice) && _ctx.$store.getters['connection/isGranted'](['device_create']))
                  ? {
                      name: "actions",
                      fn: _withCtx(() => [
                        _createVNode(NkDeviceByTypeCreateForm, {
                          "parent-id": _unref(currentDevice)?.id,
                          "type-id": _unref(currentDevice)?.type
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NkButton), { icon: "NkPencil" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('device.action.subdevice_add')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["parent-id", "type-id"])
                      ])
                    }
                  : undefined
              ]), 1032, ["title"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})